import React from "react";
import { useTheme } from "styled-components";
import { useAuth } from "../../hooks/auth";
import { Text } from "@hangar/web-components/core/Text";
import { SecurityPadlock } from "@hangar/react-icons/core/latam/Security/SecurityPadlock";
import { Breadcrumb } from "../../components/Breadcrumb";
import {
  Container
} from "./DemoAdmin.styles";

export const DemoAdmin: React.FC = () => {
  const { userProfile } = useAuth();
  const {
    tokens: { color },
  } = useTheme();

  const userName = userProfile?.givenName || userProfile?.name || userProfile?.email || "Administrador";

  return (
    <>
      {/* Breadcrumb Header */}
      <Breadcrumb
        title="Panel de Administración"
        description="Centro de control para administradores del sistema"
        items={[
          { label: "Admin Panel" }
        ]}
      />
      
      <Container>
        <Text variant="body-md" className="subtitle">
          Bienvenido, {userName} - Acceso completo al sistema - Solo accesible para rol demo.admin
        </Text>
      </Container>
    </>
  );
};